






































































































































import Vue from "vue";
import EhrNavigation from "./../interface/EhrNavigation.vue";
import SectionCard from "./../interface/SectionCard.vue";
import Swal from "sweetalert2";
import * as SwalUtils from "./../utils/SwalUtils.js";
import * as DateUtils from "./../utils/DateUtils";
import EhrStepper from "./../interface/EhrStepper.vue";
import GaForm from "./GaForm.vue";
import { AanvraagGeldigeAncienniteit } from "../../types/NBE/AanvraagGeldigeAncienniteit";
import { Step } from "../../types/interface/stepper/step";
import AanvraagGaOverzicht from "./AanvraagGaOverzicht.vue";
import InfoAlert from "../interface/InfoAlert.vue";

import { RepositoryFactory } from "./../repositories/RepositoryFactory";
import { Tewerkstellingsgegevens } from "../../types/NBE/Tewerkstellingsgegevens";
import { AanvraagGAStatus } from "../../types/NBE/AanvraagGAStatus";
import { Loopbaanfiche } from "../../types/NBE/Loopbaanfiche";
const NbeRepository = RepositoryFactory.get("nbe");
export default Vue.extend({
  name: "mijn-nbe",
  components: {
    EhrNavigation,
    SectionCard,
    GaForm,
    EhrStepper,
    AanvraagGaOverzicht,
    InfoAlert,
  },
  data() {
    return {
      aanvraagGeldigeAncienniteit: {
        pRequest: 0,
        tewerkstellingsGegevensBinnenOnderwijs: [] as Tewerkstellingsgegevens[],
        tewerkstellingsGegevensBuitenOnderwijs: [] as Tewerkstellingsgegevens[],
        tewerkstellingsGegevensOpenbaarAmbt: [] as Tewerkstellingsgegevens[],
        onbezoldigdeOnderbrekingen: [] as Tewerkstellingsgegevens[],
        loopbaanfiches: [] as Loopbaanfiche[],
        isAanvraagGA: true,
        toestemmingAanvraagLoopbaanFiche: false,
        isEersteAanvraag: false,
        einddatum: "19.09.2021",
        status: AanvraagGAStatus.Created,
      } as AanvraagGeldigeAncienniteit,
      isAddingNewBeroepservaring: false,
      activeStep: 0,
      canContinueStepper: true,
      validation: {
        aanvraagGa: {
          tewerkstellingsGegevensBinnenOnderwijs: {
            $invalid: false,
          },
          tewerkstellingsGegevensBuitenOnderwijs: {
            $invalid: false,
          },
          tewerkstellingsGegevensOpenbaarAmbt: {
            $invalid: false,
          },
          onbezoldigdeOnderbrekingen: {
            $invalid: false,
          },
        },
      },
      progressLoaded: false,
    };
  },
  created() {
    this.getNbeData();
  },
  methods: {
    async getNbeData() {
      let { data } = await NbeRepository.getNbeData();
      if (!data) {
        this.aanvraagGeldigeAncienniteit.status = AanvraagGAStatus.NotFound;
        return;
      }
      if (data.data) {
        this.aanvraagGeldigeAncienniteit = data.data;
        this.aanvraagGeldigeAncienniteit.status = data.statusCode;
      } else {
        this.getNbeProgress();
      }
      this.aanvraagGeldigeAncienniteit.einddatum = data.deadline;
      this.aanvraagGeldigeAncienniteit.pRequest = data.pRequest;
      this.progressLoaded = true;
    },
    async getNbeProgress() {
      let { data } = await NbeRepository.getNbeProgressForUser();
      if (data) {
        //this.aanvraagGeldigeAncienniteit = data.userProgressJson;
        this.aanvraagGeldigeAncienniteit.tewerkstellingsGegevensBinnenOnderwijs =
          data.userProgressJson.tewerkstellingsGegevensBinnenOnderwijs;
        this.aanvraagGeldigeAncienniteit.tewerkstellingsGegevensBuitenOnderwijs =
          data.userProgressJson.tewerkstellingsGegevensBuitenOnderwijs;
        this.aanvraagGeldigeAncienniteit.tewerkstellingsGegevensOpenbaarAmbt =
          data.userProgressJson.tewerkstellingsGegevensOpenbaarAmbt;
        this.aanvraagGeldigeAncienniteit.onbezoldigdeOnderbrekingen =
          data.userProgressJson.onbezoldigdeOnderbrekingen;
        this.aanvraagGeldigeAncienniteit.toestemmingAanvraagLoopbaanFiche =
          data.userProgressJson.toestemmingAanvraagLoopbaanFiche;
        this.activeStep = data.step;
        this.aanvraagGeldigeAncienniteit.status = AanvraagGAStatus.Created;
      }
      this.isAddingNewBeroepservaring = true;
    },
    async submitNbeRequest() {
      let res = await NbeRepository.submitAanvraagNbe(
        this.aanvraagGeldigeAncienniteit
      ).then((resp) => {
        SwalUtils.DisplaySuccessToast("Uw aanvraag werd succesvol verstuurd.");
        this.isAddingNewBeroepservaring = false;
        this.getNbeData();
      });
    },
    async saveNbeRequestProgressToDB() {
      let res = await NbeRepository.saveNbeRequestProgressToDB(
        this.aanvraagGeldigeAncienniteit,
        this.activeStep
      );
    },
    async cancelNbeRequestDB() {
      let res = await NbeRepository.cancelNbeAanvraag(
        this.aanvraagGeldigeAncienniteit
      );
    },
    addNewBeroepservaring(): void {
      this.isAddingNewBeroepservaring = true;
    },
    updateValidationState($event): void {
      this.validation = $event;
    },
    updateActiveStep(step): void {
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.activeStep = step;
      this.saveNbeRequestProgressToDB();
    },
    updateCanContinue(value): void {
      this.canContinueStepper = value;
    },
    async cancelStepper() {
      let message =
        "Bent u zeker dat u geen aanvraag geldelijke anciënniteit wilt indienen?";
      Swal.fire({
        title: message,
        text: "Deze bewerking kan niet ongedaan gemaakt worden.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonText: "Nee",
        cancelButtonColor: "#d33",
        confirmButtonText: "Ja",
      }).then((result) => {
        if (result.isConfirmed) {
          console.log("test");
          this.cancelNbeRequestDB();
          return;
        } else {
          return;
        }
      });
    },
  },
  computed: {
    hasDoneAanvraag(): boolean {
      return (
        this.aanvraagGeldigeAncienniteit.status != AanvraagGAStatus.Created
      );
    },
    aanvraagNeedsInfo(): boolean {
      return (
        this.aanvraagGeldigeAncienniteit.status == AanvraagGAStatus.NeedsInfo
      );
    },
    aanvraagNotFound(): boolean {
      return (
        this.aanvraagGeldigeAncienniteit.status == AanvraagGAStatus.NotFound
      );
    },
    aanvraagIsCancelled(): boolean {
      return (
        this.aanvraagGeldigeAncienniteit.status == AanvraagGAStatus.Cancelled
      );
    },
    isAanvraagBehandeld(): boolean {
      return (
        this.aanvraagGeldigeAncienniteit.status == AanvraagGAStatus.Processed
      );
    },
    daysLeftForAanvraag(): number {
      return DateUtils.dateDiffToday(
        DateUtils.toFormat(
          "DD.MM.YYYY",
          this.aanvraagGeldigeAncienniteit.einddatum
        )
      );
    },
    showAanvraagDaysLeftInfo(): boolean {
      return this.daysLeftForAanvraag < 7;
    },
    steps(): Step[] {
      if (this.validation) {
        return [
          {
            icon: "file-alt",
            title: "Basisgegevens",
            completed: false,
            valid: true,
          },
          {
            icon: "university",
            title: "Werkgevers onderwijs",
            completed: false,
            valid: !this.validation.aanvraagGa
              .tewerkstellingsGegevensBinnenOnderwijs.$invalid,
          },
          {
            icon: "pen",
            title: "Openbaar ambt",
            completed: false,
            valid: !this.validation.aanvraagGa
              .tewerkstellingsGegevensOpenbaarAmbt.$invalid,
          },
          {
            icon: "building",
            title: "Privé-sector",
            completed: false,
            valid: !this.validation.aanvraagGa
              .tewerkstellingsGegevensBuitenOnderwijs.$invalid,
          },
          {
            icon: "pause",
            title: "Onbezoldigde onderbrekingen",
            completed: false,
            valid: !this.validation.aanvraagGa.onbezoldigdeOnderbrekingen
              .$invalid,
          },
          {
            icon: "list",
            title: "Overzicht",
            completed: false,
            valid: true,
          },
        ];
      } else {
        return [];
      }
    },
  },
});
